<template>
	<c-dialog ref="productSelector" width="810" title="手动选择" @resolve="selectProductHandle">
		<div class="product-select flex-column">
			<m-search ref="productSearch" @search="$refs.productSelectorPagination.update(1)">
				<c-form>
					<c-form-item type="select" label="商品类目" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
					<c-form-item type="input" label="货号" name="product_itemnumber"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
				</c-form>
			</m-search>
			<ul class="product-tab flex">
				<li :class="{'z-crt': currentProductTab == 1}" @click="currentProductTab = 1">全部</li>
				<li :class="{'z-crt': currentProductTab == 2}" @click="currentProductTab = 2">已选 ({{currentProductList.length}})</li>
			</ul>
			<div v-show="currentProductTab == 1" class="flex-grow flex-column">
				<div class="product-list flex-grow">
					<div class="flex-wrap">
						<div v-for="(item, i) in productList" :key="item.product_id" class="item flex-center" :class="{'z-crt': currentProductId.includes(item.product_id)}" @click="productClickHandle(item)">
							<img :src="item.product_img_url">
							<p class="ellipsis">{{item.product_name}}</p>
							<i class="check tf tf-check"></i>
						</div>
					</div>
				</div>
				<pagination ref="productSelectorPagination" :total="productTotal" :border="false" @handle="updateProductList"></pagination>
			</div>
			<div v-show="currentProductTab == 2" class="product-list flex-grow">
				<draw-sort v-model="currentProductList" ref="productSort">
					<template v-slot="{list}">
						<div class="flex-wrap">
							<draw-item v-for="({item}, i) in list" :key="item.product_id" :index="i">
								<div class="item flex-center">
									<img :src="item.product_img_url">
									<p class="ellipsis">{{item.product_name}}</p>
									<i class="remove tf tf-cross" @mousedown.stop @click="productClickHandle(item, true)"></i>
								</div>
							</draw-item>
						</div>
					</template>
				</draw-sort>
			</div>
		</div>
	</c-dialog>
</template>

<script>
	import pagination from '@/components/public/pagination.vue'
	import drawSort from '@/components/draw_sort/index.vue'
	import drawItem from '@/components/draw_sort/item.vue'
	
	export default {
		components: {
			pagination,
			drawSort,
			drawItem
		},
		
		data() {
			return {
				currentProductTab: 1,
				productList: [],
				currentProductList: [],
				productTotal: 0
			}
		},
		
		computed: {
			currentProductId() {
				return Array.from(this.currentProductList, item => {
					return item.product_id;
				});
			}
		},
		
		methods: {
			open(opt) {
				this._selectProductConfig = opt;
				this.currentProductList = [];
				if (opt.value.length) {
					this.request({
						url: 'product/all/list',
						data: {
							product_ids: opt.value
						},
						success: data => {
							this.currentProductList = data || [];
						}
					});
				}
				this.$refs.productSelectorPagination.update(1);
				this.$refs.productSelector.open();
			},
			
			selectProductHandle(stop, next) {
				stop();
				if (this.currentProductList.length == 0) {
					this.$message({
						text: '请选择商品'
					});
					return;
				}
				next();
				this._selectProductConfig.resolve(Array.from(this.currentProductList, item => {
					return item.product_id;
				}));
			},
			
			updateProductList(data) {
				this.currentProductTab = 1;
				this.request({
					url: '/product/list',
					data: Object.assign(data, this.$refs.productSearch.get()),
					success: data => {
						this.productList = data || [];
					},
					response: res => {
						this.productTotal = res.total;
					}
				});
			},
			
			productClickHandle(item, remove) {
				if (remove || this.currentProductId.includes(item.product_id)) {
					this.currentProductList.splice(this.currentProductId.indexOf(item.product_id), 1);
				} else {
					this.currentProductList.push(item);
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.product {
		&-select {
			height: 550px;
		}
		
		&-tab {
			padding: 0 20px;
			margin-top: -10px;
			
			li {
				position: relative;
				display: inline-block;
				line-height: 40px;
				font-size: 15px;
				color: #333;
				cursor: pointer;
				
				&:nth-child(n+2) {
					margin-left: 30px;
				}
				
				&.z-crt,
				&:hover {
					font-weight: bold;
				}
				
				&.z-crt:after {
					content: '';
					position: absolute;
					left: 50%;
					bottom: 0;
					width: 30px;
					height: 2px;
					margin-left: -15px;
					background: #000;
				}
			}
		}
		
		&-list {
			padding: 0 20px 20px;
			overflow: auto;
			
			.item {
				position: relative;
				width: 100px;
				height: 100px;
				margin-right: 10px;
				margin-top: 10px;
				outline: 1px solid #ddd;
				cursor: pointer;
				
				&:hover, &.z-crt {
					outline-color: #999;
				}
				
				&.z-crt {
					.check {
						display: block;
					}
				}
				
				.check {
					display: none;
					position: absolute;
					right: 4px;
					top: 4px;
					width: 16px;
					height: 16px;
					border-radius: 8px;
					line-height: 16px;
					font-size: 12px;
					color: #fff;
					text-align: center;
					background: #3dc50b;
				}
				
				.remove {
					position: absolute;
					right: 0;
					top: 0;
					width: 20px;
					height: 20px;
					line-height: 20px;
					font-size: 12px;
					color: #fff;
					text-align: center;
					background: #DE0000;
				}
				
				p {
					position: absolute;
					left: 0;
					right: 0;
					bottom: 0;
					padding: 0 10px;
					line-height: 24px;
					font-size: 12px;
					text-align: center;
					color: #fff;
					background: rgba(0,0,0,.6);
				}
			}
		}
	}
</style>